import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";
import { brainTokens } from "../design/brainTheme";

/** The DM-Mono uppercase micro-label: AGENT · X, stage headers, group labels. */
export function MonoLabel({
  children,
  color = brainTokens.color.faint2,
  letterSpacing = "0.12em",
  size = 10,
  sx,
}: {
  children: ReactNode;
  color?: string;
  letterSpacing?: string;
  size?: number;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      component="span"
      sx={{
        fontFamily: brainTokens.font.mono,
        fontSize: size,
        fontWeight: 500,
        letterSpacing,
        textTransform: "uppercase",
        color,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
